import * as React from 'react';
import Swal from 'sweetalert2';
import { jaxa } from '../../App';
import { columns } from './gridData';
import ClientInfo from './ClientInfo';
import CreateClient from './CreateClient';
import { CustomizedDataGrid } from '../../components';
import { RefreshRounded as RefreshIcon } from '@mui/icons-material';
import { Box, Typography, Backdrop, CircularProgress, IconButton, Button } from '@mui/material';

export default function Clients(){

    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(true);

    const [clientId, setClientId] = React.useState(null);

    const [clients, setClients] = React.useState([]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const clearClientId = () => setClientId(null);

    const getClientData = async() => {
        setLoading(true);
        await jaxa.get('/get-clients').then((res) => setClients(res.data)).catch((e) => {
            Swal.fire({ title: 'Failed to load clients' });
            console.log(`Error: ${e}`);
        });
        setLoading(false);
    };

    React.useEffect(() => {
        getClientData();
    }, []);

    const loader = React.useMemo(() => (
        <Backdrop open>
            <CircularProgress/>
        </Backdrop>
    ), []);

    return (

        <Box sx={{ width: '100%', height: '100vh' }}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mb: 2, mt: 2 }}>
                <Typography component="h2" variant="h6" sx={{ mb: 2 }}>Clients</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <IconButton onClick={getClientData}>
                        <RefreshIcon/>
                    </IconButton>
                    <Button variant="outlined" onClick={handleOpen} sx={{ ml: 2 }} disabled={loading}>CREATE</Button>
                </Box>
            </Box>
            <CustomizedDataGrid columns={columns} rows={clients} onClick={e => setClientId(e)}/>
            {open ? <CreateClient open={open} handleClose={handleClose}/> : null}
            {clientId ? <ClientInfo clientId={clientId} open={Boolean(clientId)} handleClose={clearClientId}/> : null}
            {loading ? loader : null}
        </Box>

    );

};